import type { Store } from "redux";
import type { RootState } from "../redux";
import { TypesAction } from "../redux/typesAction";
import { saveState } from "../utils/storage";

let storeRef: Store<RootState> | null = null;
let isLoggingOut = false;

export function registerAuthStore(store: Store<RootState>) {
  storeRef = store;
}

/** Body JSON dạng `{ status_code: 401, message: "Unauthenticated." }` hoặc tương tự. */
export function isUnauthorizedResponseBody(data: unknown): boolean {
  if (data == null || typeof data !== "object") return false;
  const d = data as Record<string, unknown>;
  if (d.status_code == 401) return true;
  const msg = d.message;
  if (typeof msg === "string" && msg.toLowerCase().includes("unauthenticated")) {
    return true;
  }
  if (d.data != null && typeof d.data === "object") {
    return isUnauthorizedResponseBody(d.data);
  }
  return false;
}

/** Xóa phiên đăng nhập và chuyển về trang login (token hết hạn / 401). */
export function logoutDueToUnauthorized(): void {
  if (isLoggingOut) return;
  isLoggingOut = true;
  try {
    if (storeRef) {
      storeRef.dispatch({ type: TypesAction.LOGOUT });
      saveState(storeRef.getState());
    } else {
      localStorage.removeItem("state");
    }
  } catch {
    localStorage.removeItem("state");
  }
  window.location.replace("/login?session=expired");
}
